import { mergeStyleSets } from '@fluentui/react';

export default mergeStyleSets({
  uploader: {
    display: 'none',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '10px',
  },
});
